import SettingsExpertTeamMemberComponent from './team-member.component'

const SettingsExpertTeamMemberModule = angular.module('cdbl.team-member', [

])
  .component('cdblSettingsExpertTeamMember', SettingsExpertTeamMemberComponent)
  .name

export default SettingsExpertTeamMemberModule
